import api from './api';

const consultantApi = {
  getDashboardStats: () => api.get('/consultant/dashboard/stats'),
  
  getProfile: () => api.get('/consultant/profile'),
  
  updateProfile: (data) => api.put('/consultant/profile', data),
  
  getAvailableCompanies: (params) => api.get('/consultant/companies/available', { params }),
  
  getMyCompanies: (params) => api.get('/consultant/companies', { params }),
  
  sendCompanyRequest: (companyId) => api.post('/consultant/companies/request', { companyId }),
  
  leaveCompany: (associationId) => api.delete(`/consultant/companies/${associationId}/leave`),
  
  createJob: (jobData) => {
    return api.post('/consultant/jobs', jobData);
  },
  
  getMyJobs: (params) => api.get('/consultant/jobs', { params }),
  
  getJobById: (jobId) => api.get(`/consultant/jobs/${jobId}`),
  
  updateJob: (jobId, jobData) => api.put(`/consultant/jobs/${jobId}`, jobData),
  
  sendJobForApproval: (jobId) => api.post(`/consultant/jobs/${jobId}/submit-approval`),
  
  publishJob: (jobId) => api.post(`/consultant/jobs/${jobId}/publish`),

  updateJobStatus: (jobId, status) => api.patch(`/jobs/${jobId}/status`, { status }),

  deleteJob: (jobId) => api.delete(`/jobs/${jobId}`),
  
  getApplications: (params) => api.get('/consultant/applications', { params }),
  
  shortlistCandidate: (applicationId) => api.post(`/consultant/applications/${applicationId}/shortlist`),
  
  rejectCandidate: (applicationId, reason) => api.post(`/consultant/applications/${applicationId}/reject`, { reason })
};

export default consultantApi;
